<div class="animated fadeIn">
  <div class="kite-section-card">
    <div class="kite-section-title flex-wrap gap-2">
      <span>ECO Service Orders</span>
    </div>

    <div class="row align-items-end g-2 mb-3 pt-1">
      <!-- Search Input on the LEFT -->
      <div class="col-xl-4 col-lg-5 col-md-6 col-12 mb-2">
        <app-search-input
          [placeholder]="'Search by order #, driver...'"
          (searchChange)="onSearch($event)">
        </app-search-input>
      </div>

      <!-- Date Filter on the RIGHT -->
      <div class="col-xl-8 col-lg-7 col-md-6 col-12 mb-2 d-flex justify-content-md-end justify-content-start align-items-end">
        <app-date-filter (filterChange)="onDateFilterChange($event)"></app-date-filter>
      </div>
    </div>

    <div class="w-100 position-relative">
      <app-kite-grid
        [columnDefs]="columnDefs"
        [rowData]="orders()"
        [totalRecords]="total()"
        [pageSize]="pageSize"
        [currentPage]="page()"
        [loading]="loading()"
        [gridOptions]="gridOptions"
        (pageChange)="onPageChange($event)"
        (cellClicked)="onCellClicked($event)">
      </app-kite-grid>
    </div>
  </div>
</div>

@if (loading()) {
  <app-page-loading [absolute]="true"></app-page-loading>
}
